module.exports = __webpack_public_path__ + "static/feature1-e471d77e8babb756257627e06ed2eb92.png";